import React from 'react';
import { Input, Button } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';
import LiveStreamEmbed from './LiveStreamEmbed';

const LiveStreamPanel = ({
    liveStreamUrl = null,
    liveStreamInput = '',
    onInputChange,
    onUpdate,
    onRemove,
    updating = false,
    isOwner = false,
    compact = false,
    embedCompact = false,
    showPreview = true,
    active = true
}) => {
    if (!isOwner && !liveStreamUrl) {
        return null;
    }

    const cardStyle = {
        width: '100%',
        maxWidth: compact ? '720px' : '100%',
        marginBottom: compact ? '12px' : 0,
        padding: compact ? '12px' : 0,
        background: compact ? 'white' : 'transparent',
        borderRadius: compact ? '12px' : 0,
        boxShadow: compact ? '0 8px 25px rgba(0,0,0,0.1)' : 'none',
        border: compact ? '1px solid rgba(24, 144, 255, 0.15)' : 'none'
    };

    return (
        <div style={cardStyle}>
            {liveStreamUrl && (
                <div style={{
                    fontSize: '14px',
                    fontWeight: 700,
                    color: '#ff4d4f',
                    marginBottom: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <span style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: '#ff4d4f',
                        animation: 'pulse 1.5s infinite'
                    }} />
                    Live Stream
                </div>
            )}

            {isOwner && (
                <div style={{ marginBottom: liveStreamUrl && showPreview ? '16px' : 0 }}>
                    {!liveStreamUrl && !compact && (
                        <div style={{
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#1890ff',
                            marginBottom: '10px'
                        }}>
                            Set up your live stream before the auction starts
                        </div>
                    )}
                    <p style={{
                        fontSize: '12px',
                        color: '#7f8c8d',
                        marginBottom: '8px',
                        lineHeight: 1.4
                    }}>
                        Paste a YouTube, TikTok, or Facebook live URL. TikTok LIVE requires your domain to be approved by TikTok.
                    </p>
                    <Input
                        value={liveStreamInput}
                        onChange={(e) => onInputChange?.(e.target.value)}
                        placeholder="https://youtube.com/live/... or TikTok/Facebook live URL"
                        allowClear
                        style={{ marginBottom: '10px' }}
                    />
                    <div style={{ display: 'flex', gap: 8 }}>
                        <Button
                            type="primary"
                            icon={<PlayCircleOutlined />}
                            loading={updating}
                            onClick={() => onUpdate?.()}
                            style={{ flex: 1 }}
                        >
                            {liveStreamUrl ? 'Update Stream' : 'Start Stream'}
                        </Button>
                        {liveStreamUrl && (
                            <Button
                                danger
                                loading={updating}
                                onClick={() => onRemove?.()}
                            >
                                Remove
                            </Button>
                        )}
                    </div>
                </div>
            )}

            {showPreview && liveStreamUrl && active && (
                <LiveStreamEmbed
                    url={liveStreamUrl}
                    title="Auction Live Stream"
                    compact={embedCompact}
                    active={active}
                />
            )}
        </div>
    );
};

export default LiveStreamPanel;
